module.exports = __webpack_public_path__ + "14e95d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_ordering_hourly_clock@2x.png
// module id = 1273
// module chunks = 0